var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    height: "100%",
    viewBox: "0 0 192 192",
    xmlSpace: "preserve",
    preserveAspectRatio: "xMinYMin",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_167_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_791_",
    fill: "#FF0000",
    cx: 96,
    cy: 96,
    r: 88
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_41_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    fill: "#FFFFFF",
    d: "M96,54.04c23.14,0,41.96,18.82,41.96,41.96S119.14,137.96,96,137.96S54.04,119.14,54.04,96 S72.86,54.04,96,54.04 M96,50c-25.41,0-46,20.59-46,46s20.59,46,46,46s46-20.59,46-46S121.41,50,96,50L96,50z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_274_",
    fill: "#FFFFFF",
    points: "80,119 119,95 80,73  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeMusic);
export default __webpack_public_path__ + "static/media/youtube-music.1b6ae0722dd4893d9b4bf263d9c9f7d0.svg";
export { ForwardRef as ReactComponent };